export default __webpack_public_path__ + "static/media/Tincodong_thumbnail_3.b61ef68d.png";